import { useEffect, useState } from "react";

const navItems = [
  { key: "ways", label: "获取方式" },
  { key: "hot", label: "热门资源" },
  { key: "category", label: "全部分类" },
  { key: "updates", label: "最新更新" },
  { key: "guide", label: "使用指南" },
  { key: "faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id: string) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled || open ? "bg-background-50/95 backdrop-blur border-b border-background-200/70" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 md:px-6" aria-label="主导航">
        <a
          href="#top"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center gap-2"
          aria-label="宅宅资源库首页"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-archive-drawer-line text-lg"></i>
          </span>
          <span
            className={`font-heading text-lg font-bold whitespace-nowrap ${
              scrolled || open ? "text-foreground-950" : "text-background-50"
            }`}
          >
            宅宅资源库
          </span>
        </a>

        <ul className="hidden items-center gap-7 md:flex">
          {navItems.map((item) => (
            <li key={item.key}>
              <a
                href={`#${item.key}`}
                onClick={(e) => {
                  e.preventDefault();
                  scrollTo(item.key);
                }}
                className={`text-sm whitespace-nowrap transition-colors ${
                  scrolled ? "text-foreground-700 hover:text-primary-600" : "text-background-50/90 hover:text-background-50"
                }`}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden items-center gap-3 md:flex">
          <button
            onClick={() => scrollTo("hot")}
            className="flex h-10 items-center gap-2 rounded-md bg-primary-500 px-4 text-sm font-medium whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-search-line"></i>
            立即查找
          </button>
        </div>

        <button
          className={`flex h-10 w-10 items-center justify-center rounded-md md:hidden ${
            scrolled || open ? "text-foreground-950" : "text-background-50"
          }`}
          onClick={() => setOpen((v) => !v)}
          aria-label="展开或收起导航菜单"
          aria-expanded={open}
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-3 md:hidden">
          <ul className="flex flex-col gap-1">
            {navItems.map((item) => (
              <li key={item.key}>
                <a
                  href={`#${item.key}`}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollTo(item.key);
                  }}
                  className="block rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100"
                >
                  {item.label}
                </a>
              </li>
            ))}
            <li className="pt-2">
              <button
                onClick={() => scrollTo("hot")}
                className="flex h-10 w-full items-center justify-center gap-2 rounded-md bg-primary-500 text-sm font-medium whitespace-nowrap text-background-50"
              >
                <i className="ri-search-line"></i>
                立即查找
              </button>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}